(function ($) {
  $(document).ready(function ($) {
    /** TEMPORARY – TREVOR WILL REMOVE WHEN GOES LIVE **/
    let clickCount = 0;
    $("#preview-remover").click(function (event) {
      clickCount++;

      if (clickCount === 3) {
        $(".preview-hype-page").remove();
      }
    });
    /** END: TEMPORARY – TREVOR WILL REMOVE WHEN GOES LIVE **/

    var inHeight = window.innerHeight / 100;
    var inHeight2 = window.innerHeight / 100;
    var navheight = $("#shopify-section-navigation").outerHeight(true);
    var announcementHeight = $("#notification-msg").outerHeight(true);

    document.documentElement.style.setProperty("--vh", inHeight + "px");
    document.documentElement.style.setProperty("--vhm", inHeight2 + "px");
    document.documentElement.style.setProperty("--navHeight", navheight + "px");
    document.documentElement.style.setProperty("--announcementHeight", announcementHeight + "px");

    $(window).resize(function (event) {
      inHeight2 = window.innerHeight / 100;
      navheight = $("#shopify-section-navigation").outerHeight(true);
      var announcementHeight = $("#shopify-section-navigation").outerHeight(true);
      announcementHeight = $("#notification-msg").outerHeight(true);
      document.documentElement.style.setProperty("--vhm", inHeight2 + "px");
      document.documentElement.style.setProperty("--navHeight", navheight + "px");
      document.documentElement.style.setProperty("--announcementHeight", announcementHeight + "px");
    });

    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    window.refreshScrollTrigger = function () {
      ScrollTrigger.refresh();
    };

    /*
    // debugging for tab/enter users
    $(document).on('keydown', function (event) {
      if (event.keyCode === 13) {
        // Enter key has keyCode 13
        console.log(event.target); // Logs the specific DOM element that triggered the keydown event
      }
    });
    */

    /*****************************************************************
      LazySizes Event Listener for GSAP ScrollTrigger Refresh
    *****************************************************************/
    /*
    document.addEventListener("lazyloaded", function (e) {
      // This event is triggered every time a lazyloaded image is fully loaded, aka when an image hits viewport.
      ScrollTrigger.refresh();
      //console.log("Lazyloading's ScrollTrigger refresh ran");
    });
    */

    /*****************************************************************
      Touch fix for devices to mimick hover effects
    ******************************************************************/
    $("*")
      .on("touchstart", function () {
        $(this).trigger("hover");
      })
      .on("touchend", function () {
        $(this).trigger("hover");
      });

    /***********************************************************************************
      Scroll from top add class to the body for the nav so nav is legible,
      and then also add and remove classes based on if the user is scrolling up or down
    ************************************************************************************/
    var lastScrollTop = 0;
    $(window).scroll(function () {
      var currentScrollTop = $(this).scrollTop();

      // if the user has left the top of the page by more than 20 pixels
      if (currentScrollTop > 50) {
        $("body").addClass("scrolled");

        // Check if the user is scrolling down
        if (currentScrollTop > lastScrollTop) {
          $("body").addClass("scrolling-down");
        } else if (lastScrollTop - currentScrollTop >= 10) {
          // Check if scrolled up at least 20 pixels
          $("body").removeClass("scrolling-down");
        }
      } else {
        $("body").removeClass("scrolled scrolling-down");
      }

      lastScrollTop = currentScrollTop;
    });

    /*****************************************************************
      If announcement bar is showing, add a class to the navigation
    ******************************************************************/
    if ($("aside#notification-msg").length) {
      $("body").addClass("announcement-showing");
    }

    /*****************************************************************
      Opening & closing the navigation menu buttons
    ******************************************************************/
    $("#MainContent").click(function (event) {
      if ($("body").hasClass("menu-open")) {
        $("body").removeClass("menu-open noscroll");
      }

      if ($("body").hasClass("cart-open")) {
        $("body").removeClass("cart-open noscroll");
      }
    });

    $("#mobile-navBtn").click(function (event) {
      if ($("body").hasClass("menu-open")) {
        $("body").removeClass("menu-open noscroll");
      } else {
        $("body").addClass("menu-open noscroll");
      }
    });

    $("#menu-navBtn").click(function (event) {
      if ($("body").hasClass("menu-open")) {
        $("body").removeClass("menu-open noscroll");
      }
    });

    /*****************************************************************
      For when we do a img src="example.svg" SVG use instead of the 
      <svg> html markup
    ******************************************************************/
    $("img.svg").each(function () {
      console.log("do we need this?");
      var $img = $(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");
      var dataFill = $img.attr("data-fill-color");
      var dataStroke = $img.attr("data-stroke-color");
      $.get(
        imgURL,
        function (data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find("svg"),
            $svgElements = $(data).find("svg *");
          // Add replaced image's ID to the new SVG
          if (typeof imgID !== "undefined") {
            $svg = $svg.attr("id", imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== "undefined") {
            $svg = $svg.attr("class", imgClass + " replaced-svg");
          }

          if ($img.parent(".svg-egg").length) {
            $svgElements = $svgElements.removeAttr("stroke");
          }
          // Add Fill color of SVG
          if (typeof dataFill !== "undefined") {
            $svg = $svg.attr("fill", dataFill);
          }

          // Add Stroke color of SVG
          if (typeof dataStroke !== "undefined") {
            $svg = $svg.attr("stroke", dataStroke);
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr("xmlns:a");

          // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
          if (!$svg.attr("viewBox") && $svg.attr("height") && $svg.attr("width")) {
            $svg.attr("viewBox", "0 0 " + $svg.attr("height") + " " + $svg.attr("width"));
          }
          // Replace image with new SVG
          $img.replaceWith($svg);
        },
        "xml"
      );
    });

    /*****************************************************************
     * Scroll Down to next section
     *****************************************************************/
    if ($(".scroll-down").length) {
      $(".scroll-down").click(function (e) {
        e.preventDefault();
        var nextSection = $(this).parent().closest(".shopify-section").next();

        $("html, body").animate(
          {
            scrollTop: nextSection.offset().top + 1,
          },
          800,
          function () {
            // window.location.hash = hash;
          }
        );
      });
    }

    /*****************************************************************
      Klaviyo form integration
    *****************************************************************/
    function KlaviyoSubscribe(listID, email, source) {
      var subscribed = false;
      $.ajax({
        type: "POST",
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        data: {
          g: listID,
          $fields: "$source, $consent, $email, Accepts Marketing",
          $email: email,
          $consent: ["email"],
          //pass in additional fields
          AcceptsMarketing: true,
          $source: source,
        },
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache",
        },
        error: function (err) {
          console.log("Could not connect to Klaviyo.");
          console.log(err);
        },
        success: function (res) {
          console.log("success");
          console.log(res);
          subscribed = true;

          if (res.data.is_subscribed == false) {
            $("#footer-klaviyo").remove();
            $("#klaviyo-message").addClass("success");
            $("#klaviyo-message").append(msg);
          }

          if (res.data.is_subscribed == true) {
            var failmsg = "<p>That email is already subscribed to our list.</p>";
            $("#footer-klaviyo").remove();
            $("#klaviyo-message").addClass("success");
            $("#klaviyo-message").append(failmsg);
          }
        },
        async: false,
      });
      return subscribed;
    }

    $("#footer-subscribe").click(function (event) {
      event.preventDefault();
      const listID = "Rc4wK9"; //list ID for Klaviyo goes here
      const email = $("#footer-klaviyo-email").val();
      const source = "Footer Signup";
      //console.log(listID);
      if (email != "") {
        KlaviyoSubscribe(listID, email, source);
      } else {
        // do nothing
      }
    });
    /*****************************************************************
      END Klaviyo form integration
    *****************************************************************/

    /*****************************************************************
      Nav menu hover effects
    *****************************************************************/
    var $navItem = $("#header .menu .nav-item");
    var $bgItem = $(".bg-gradient-contain .bg-gradient-item");
    $navItem
      .on("mouseenter", function () {
        $bgItem.eq($(this).index()).addClass("active");
      })
      .on("mouseleave", function () {
        $bgItem.removeClass("active");
      });

    /*****************************************************************
      END Nav menu hover effects
    *****************************************************************/

    /*****************************************************************
     Accordions
    ******************************************************************/
    if ($(".accordion").length) {
      $(".accordion-tab button").click(function (event) {
        var me = $(this),
          parent = $(this).parent().parent(".accordion-tab"),
          botOpen = $(parent).children("dd"),
          botHeight = $(botOpen).children(".content").outerHeight(true);

        // Toggle current accordion
        if ($(parent).hasClass("open")) {
          $(parent).removeClass("open");
          $(me).attr("aria-expanded", "false");
          $(botOpen).attr("aria-hidden", "true");
          $(botOpen).css("height", 0);
        } else {
          // Close all other accordions first, if dontCloseAll isn't there
          if (!$(me).hasClass("dontCloseAll")) {
            $(".accordion-tab").each(function (index, el) {
              var botReset = $(this).children("dd");
              $(this).removeClass("open");
              $(this).children("dt").children("button").attr("aria-expanded", "false");
              $(botReset).attr("aria-hidden", "true");
              $(botReset).css("height", "0");
            });
          }

          $(me).attr("aria-expanded", "true");
          $(parent).addClass("open");
          $(botOpen).attr("aria-hidden", "false");
          $(botOpen).css("height", botHeight);

          ScrollTrigger.refresh();
        }

        // GSAP Pin Fix -- Adjusted for accordion animation completion
        if (!isMobile) {
          var stickyProductScroll = $(".sticky-inner-contain");
          if ($(me).attr("aria-expanded") == "true") {
            stickyProductScroll.removeClass("transform-helper");
            stickyProductScroll.css({
              transform: "translate3d(0, -" + botHeight + "px, 0)",
            });
          } else {
            stickyProductScroll.css({ transform: "translate3d(0,0,0)" });
            $(".sticky-inner-contain").addClass("transform-helper");
          }
        }
      });

      // Resize listener for open accordions
      $(window).resize(function () {
        if ($(".accordion-tab.open").length) {
          var getBot = $(".accordion-tab.open").children("dd");
          var newHeight = $(getBot).children(".content").outerHeight(true);
          $(getBot).css("height", newHeight);

          ScrollTrigger.refresh();
        }
      });
    }
    /*****************************************************************
     END Accordions
    ******************************************************************/

    /*****************************************************************
      Animation Library / Area.
      GSAP + GSAP ScrollTrigger
    ******************************************************************/
    gsap.registerPlugin(ScrollTrigger);
    $(window).on("load", function () {
      // GSAP Custom Parallax
      gsap.utils.toArray("[data-gsap]").forEach((el) => {
        const dataScrollnode = $(el)[0];
        let startOpt;

        // Check if Parallax is above the fold on page load if it is will start parallax from beginning
        if (dataScrollnode.hasAttribute("data-gsap-above")) {
          startOpt = 0;
        } else {
          startOpt = "top bottom";
        }

        const obj = eval("(" + el.dataset.gsap + ")");
        // Scroll Options
        const scrollProps = {
          scrollTrigger: {
            // start: "top bottom",
            start: startOpt,
            end: "bottom top",
            trigger: el,
            scrub: 1, // Sets a 1 second delay, true is default for scrub
            // markers: true,
          },
        };
        // Add values to object from element data attribute
        Object.assign(scrollProps, obj);

        gsap.to(el, scrollProps);
      });

      // Scroll into view section animations
      gsap.utils.toArray(".fade-in-up").forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            start: "top 94%",
            end: "bottom top",
            trigger: el,
            toggleClass: "show",
            once: true,
          },
        });
      });

      gsap.utils.toArray(".fade-in").forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            start: "top 94%",
            end: "bottom top",
            trigger: el,
            toggleClass: "show",
            once: true,
          },
        });
      });

      gsap.utils.toArray(".fade-in-up").forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            start: "top 94%",
            end: "bottom top",
            trigger: el,
            toggleClass: "show",
            once: true,
          },
        });
      });

      gsap.utils.toArray(".parallax-image-up").forEach((el) => {
        gsap.to(el, {
          y: "-18%",
          scrollTrigger: {
            trigger: el,
            start: "top bottom",
            scrub: true,
          },
        });
      });

      // Footer Overlap
      function getFooterHeight() {
        return document.querySelector(".main-footer").offsetHeight / 2;
      }

      $(window).on("resize", function () {
        if (window.matchMedia("(min-width: 768px)").matches) {
          setTimeout(function () {
            ScrollTrigger.refresh(true);
          }, 1000);
        }
      });

      gsap.to(".pin-spacer-special", {
        top: () => getFooterHeight(),
        scrollTrigger: {
          trigger: ".main-footer",
          start: "top bottom",
          scrub: 0.2,
          // markers: true,
        },
      });
    }); // end of .load() for GSAP

    /*****************************************************************
     * COUNTDOWN TIMER FUNCTIONALITY
     *****************************************************************/
    function initCountdownTimer() {
      const countdownElement = document.getElementById("countdown-timer");
      if (!countdownElement) return;

      const endDate = countdownElement.getAttribute("data-end-date");
      const timezone = countdownElement.getAttribute("data-timezone");
      const expiredText = countdownElement.getAttribute("data-expired-text");

      if (!endDate) return;

      // Parse the date string and create a Date object in the specified timezone
      const [datePart, timePart] = endDate.split(" ");
      const [year, month, day] = datePart.split("-");
      const [hour, minute] = timePart.split(":");

      // Create the target date
      const targetDate = new Date();
      targetDate.setFullYear(parseInt(year));
      targetDate.setMonth(parseInt(month) - 1); // Month is 0-indexed
      targetDate.setDate(parseInt(day));
      targetDate.setHours(parseInt(hour));
      targetDate.setMinutes(parseInt(minute));
      targetDate.setSeconds(0);
      targetDate.setMilliseconds(0);

      // Adjust for timezone offset (simplified approach)
      const timezoneOffsets = {
        "America/Los_Angeles": -8, // PST (adjust for DST as needed)
        "America/New_York": -5, // EST (adjust for DST as needed)
        "America/Chicago": -6, // CST (adjust for DST as needed)
        "America/Denver": -7, // MST (adjust for DST as needed)
        UTC: 0,
      };

      const offsetHours = timezoneOffsets[timezone] || -8; // Default to PST
      const offsetMs = offsetHours * 60 * 60 * 1000;
      const adjustedTargetDate = new Date(targetDate.getTime() - offsetMs);

      function updateCountdown() {
        const now = new Date().getTime();
        const distance = adjustedTargetDate.getTime() - now;

        if (distance < 0) {
          countdownElement.innerHTML = `<span class="countdown-expired">${expiredText}</span>`;
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        let countdownHTML = '<div class="countdown-units">';

        if (days > 0) {
          countdownHTML += `<span class="countdown-unit"><span class="countdown-number">${days}</span><span class="countdown-label">Days</span></span>`;
        }

        countdownHTML += `<span class="countdown-unit"><span class="countdown-number">${hours
          .toString()
          .padStart(2, "0")}</span><span class="countdown-label">Hours</span></span>`;
        countdownHTML += `<span class="countdown-unit"><span class="countdown-number">${minutes
          .toString()
          .padStart(2, "0")}</span><span class="countdown-label">Min</span></span>`;
        countdownHTML += `<span class="countdown-unit"><span class="countdown-number">${seconds
          .toString()
          .padStart(2, "0")}</span><span class="countdown-label">Sec</span></span>`;
        countdownHTML += "</div>";

        countdownElement.innerHTML = countdownHTML;
      }

      // Initial update
      updateCountdown();

      // Update every second
      setInterval(updateCountdown, 1000);
    }

    // Initialize countdown timer when DOM is ready
    initCountdownTimer();

    /*****************************************************************
     * SCROLL TO SECTION FUNCTIONALITY
     *****************************************************************/
    $(document).on("click", ".scroll-to-section", function (e) {
      e.preventDefault();

      const target = $(this).data("target");
      if (!target) return;

      const $targetElement = $(target);
      if ($targetElement.length === 0) return;

      // Calculate the offset position accounting for any fixed header
      const headerOffset = navheight || 0;
      const targetPosition = $targetElement.offset().top - headerOffset;

      // Smooth scroll to the target section
      $("html, body").animate(
        {
          scrollTop: targetPosition,
        },
        800,
        "swing"
      );
    });
  }); // end .ready()
})(jQuery);
